module.exports = __webpack_public_path__ + "static/gatsbyWebResume-48c447b2765d3fed7159d21c0ebd595f.png";